import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate } from '@angular/router';

import { map, Observable } from 'rxjs';

import { IRouteData } from '@eai-tdv/core/models';
import { PermissionsService } from '@eai-tdv/core/services/permissions';

import { NavigationWebService } from '../services/navigation.service';

@Injectable({ providedIn: 'root' })
export class PermissionsGuard implements CanActivate {
  constructor(
    private navigationS: NavigationWebService,
    private permissionsS: PermissionsService,
  ) {}

  public canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    return this.permissionsS.selectPermissions().pipe(
      // we don't filter here cos before each PermissionGuard must be AuthGuard
      map(permissions => {
        const data = route.data as IRouteData;
        const isAvailable =
          data.permissions?.some(routePerm => {
            return (
              permissions?.accessMap?.[routePerm.entity]?.[routePerm.action] ||
              false
            );
          }) || false;
        if (!isAvailable) {
          this.navigationS.goToProfile(); // todo - temp if patients list page forbidden we need to redirect user  to base path but now base path is patients view
        }
        return isAvailable;
      }),
    );
  }
}
